import { render } from "./ControlButtons.vue?vue&type=template&id=f090183a&scoped=true"
import script from "./ControlButtons.vue?vue&type=script&lang=ts"
export * from "./ControlButtons.vue?vue&type=script&lang=ts"

import "./ControlButtons.vue?vue&type=style&index=0&id=f090183a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f090183a"

export default script